import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PlatformAccessAuditEvent } from '../models/platform-access/platform-access-audit-event.interface';
import { PlatformAccessAuditQuery } from '../models/platform-access/platform-access-audit-query.interface';
import { SuperAdminUser } from '../models/platform-access/super-admin-user.interface';

@Injectable({
  providedIn: 'root',
})
export class PlatformAdminService {
  private readonly httpClient = inject(HttpClient);

  private readonly platformAccessUrl = `${environment.apiUrl}/admin/platform-access`;

  public getAuditEvents(query: PlatformAccessAuditQuery = {}): Observable<PlatformAccessAuditEvent[]> {
    let httpParams = new HttpParams();
    const normalizedLimit = query.limit ?? 20;

    httpParams = httpParams.set('limit', normalizedLimit);

    if (query.email?.trim()) {
      httpParams = httpParams.set('email', query.email.trim());
    }

    if (query.dateFrom) {
      httpParams = httpParams.set('dateFrom', query.dateFrom);
    }

    if (query.dateTo) {
      httpParams = httpParams.set('dateTo', query.dateTo);
    }

    return this.httpClient
      .get<PlatformAccessAuditEvent[]>(`${this.platformAccessUrl}/audit-events`, { params: httpParams })
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public getSuperAdmins(): Observable<SuperAdminUser[]> {
    return this.httpClient.get<SuperAdminUser[]>(`${this.platformAccessUrl}/super-admins`).pipe(
      catchError((error: unknown) => {
        throw new Error(`An error occurred: ${error}`);
      }),
    );
  }

  public grantSuperAdmin(email: string): Observable<SuperAdminUser> {
    return this.httpClient
      .post<SuperAdminUser>(`${this.platformAccessUrl}/super-admins`, { email })
      .pipe(
        catchError((error: unknown) => {
          throw new Error(`An error occurred: ${error}`);
        }),
      );
  }

  public revokeSuperAdmin(userId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.platformAccessUrl}/super-admins/${userId}`).pipe(
      catchError((error: unknown) => {
        throw new Error(`An error occurred: ${error}`);
      }),
    );
  }
}
